import { FormDialog } from 'components/dialog/form'
import { SearchsDrugResult, usePostSearchsDrug } from 'interface/search/drug'
import { useSearchsDrugForm, SearchsDrugForm } from '../form'

type AddSearchsDrugDialogProps = {
  searchId: number
  onSubmit: (result: SearchsDrugResult) => void
  onClose: () => void
}
export const AddSearchsDrugDialog = ({
  searchId,
  onSubmit,
  onClose
}: AddSearchsDrugDialogProps) => {
  const [postState, submit] = usePostSearchsDrug(searchId, { onPosted: onSubmit })
  const form = useSearchsDrugForm({ onSubmit: submit })
  return (
    <FormDialog
      open
      fullWidth
      maxWidth="md"
      title="分析対象の薬剤を登録"
      isLoading={postState.posting}
      error={postState.error}
      body={<SearchsDrugForm {...form}/>}
      submitLabel="確定"
      isValid={form.formState.isValid}
      onSubmit={form.submit}
      onClose={onClose}
    />
  )
}
